import React from "react";
// import Slider from "react-slick";
import styled from "styled-components";

// Assets
// import ClientLogo01 from "../../assets/img/clients/logo01.svg";
// import ClientLogo02 from "../../assets/img/clients/logo02.svg";
// import ClientLogo03 from "../../assets/img/clients/logo03.svg";
// import ClientLogo04 from "../../assets/img/clients/logo04.svg";
// import ClientLogo05 from "../../assets/img/clients/logo05.svg";
// import ClientLogo06 from "../../assets/img/clients/logo06.svg";

export default function ClientSlider() {
  // const settings = {
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 6,
  //   slidesToScroll: 2,
  //   arrows: false,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };

  return (
    <Container>
      <AboutSection>
        <h2 style={{color: "#7620ff"}}>ABOUT</h2>
        <p style={{textAlign:"center"}}>
          WE ARE SOFTWARE CONSULTING & KNOWLEDGE SHARING COMPANY. </p><p>We are a next-generation digital services and consulting firm enabling clients to navigate their digital transformation.
          Changes start in a company that has the right people and a growth mindset. SRR INTECH brings together hundreds of creators and technologists who have been crafting reliable solutions with lasting value for years.
          We’re unstoppable in finding the best way to turn your bold vision into a big success story that spans borders and time zones.
        </p>
      </AboutSection>

      {/* <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo01} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo02} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo03} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo04} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo05} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo06} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo03} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo04} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo01} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo02} alt="client logo" />
        </LogoWrapper>
      </Slider> */}
    </Container>
  );
}

const Container = styled.div`
  padding: 40px 0;
  background-color: #dcb9ff;
  color: #000; // Ensures readable text on yellow background
    font-family: 'Poppins', sans-serif; /* <-- Apply Poppins font */

`;

const AboutSection = styled.div`
  max-width: 900px;
  margin: 0 auto 40px auto;
  padding: 0 20px;
  text-align: center;
  text-align: center;
  

  h2 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  p {
    font-size: 16px;
    line-height: 1.6;
    color: #333;
     text-align: justify;
  }
`;

// const LogoWrapper = styled.div`
//   width: 100%;
//   height: 100px;
//   cursor: pointer;
//   :focus-visible {
//     outline: none;
//     border: 0px;
//   }
// `;

// const ImgStyle = styled.img`
//   width: 100%;
//   height: 100%;
//   padding: 10%;
// `;
